import {
    Select,
    SelectContent,
    SelectItem,
    SelectList,
    SelectTrigger,
    SelectValue,
} from '@plato/ui/components/select';
import { cn } from '@plato/ui/util/classes';
import { useTranslation } from 'react-i18next';
import { Input } from '../ui/input.tsx';
import type { RelativeDateRange } from './types/filter-types.ts';
import { RelativeTimeUnit } from './types/filter-types.ts';

type RelativeRangeInputProps = {
    value: RelativeDateRange;
    onChange: (value: RelativeDateRange) => void;
    className?: string;
};

type UnitOption = { value: RelativeTimeUnit; label: string };

export function RelativeRangeInput({ value, onChange, className }: RelativeRangeInputProps) {
    const { t } = useTranslation('filters');

    const handleValueChange = (val: string) => {
        const count = Number.parseInt(val) || 0;
        onChange({ ...value, count });
    };

    const units: UnitOption[] = [
        { value: RelativeTimeUnit.DAYS, label: t('date_range_filter__unit_days') },
        { value: RelativeTimeUnit.WEEKS, label: t('date_range_filter__unit_weeks') },
        { value: RelativeTimeUnit.MONTHS, label: t('date_range_filter__unit_months') },
    ];

    return (
        <div className={cn('flex items-center space-x-2', className)}>
            <Input
                type="number"
                min="0"
                value={value.count.toString()}
                onChange={(e) => {
                    handleValueChange(e.target.value);
                }}
                className="w-20"
                placeholder="0"
            />

            <Select
                title={t('date_range_filter__unit_label')}
                items={units}
                value={value.unit}
                onValueChange={(unit) => {
                    if (unit) {
                        onChange({ ...value, unit });
                    }
                }}
            >
                <SelectTrigger className="w-32">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    <SelectList>
                        {(unit: UnitOption) => <SelectItem key={unit.value} value={unit} />}
                    </SelectList>
                </SelectContent>
            </Select>
        </div>
    );
}
